import ToolShell, { OutputBlock, HookRow } from "@/pages/tools/ToolShell";

export default function OneDive() {
  return (
    <ToolShell
      testid="tool-one-dive-page"
      eyebrow="Tool" toolKey="one_dive"
      title="One Dive = 5 Reels"
      subtitle="Multiply a single dive into five distinct angles: mistake, gear, emotional, skill, identity."
      endpoint="/tools/one-dive-five-reels"
      fields={[
        { key: "dive_description", label: "Describe the dive in detail", type: "textarea", rows: 8, required: true, placeholder: "Location, depth, conditions, what you filmed, what went wrong, what surprised you, what you noticed about your buoyancy or breath, what gear you used, what you'd do differently…" },
      ]}
      renderOutput={(o) => (
        <>
          {o.dive_summary && <OutputBlock testid="output-summary" label="Dive Summary">{o.dive_summary}</OutputBlock>}
          {(o.reels || []).map((r, i) => (
            <div key={i} className="dms-card p-6 space-y-4" data-testid={`reel-${i + 1}`}>
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-[11px] tracking-[0.22em] uppercase font-bold text-[#1D4E89]">Reel {i + 1}</span>
                <span className="dms-badge">{r.angle}</span>
                {r.hook_archetype && <span className="dms-badge">{r.hook_archetype}</span>}
                {r.psychological_trigger && <span className="text-[11px] tracking-[0.18em] uppercase font-bold text-[#64748B]">{r.psychological_trigger}</span>}
              </div>
              <h3 className="font-heading font-bold text-[18px] text-[#0A2342]">{r.reel_concept}</h3>
              <div>
                <div className="dms-label mb-2">Hooks</div>
                {(r.hooks || []).map((h, k) => <HookRow key={k} hook={h} />)}
              </div>
              <div>
                <div className="dms-label mb-2">Caption ({(r.caption || "").length} chars)</div>
                <div className="whitespace-pre-wrap leading-relaxed text-[15px]">{r.caption}</div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
                <div><div className="dms-label mb-1">CTA</div>{r.cta}</div>
                <div><div className="dms-label mb-1">Pinned Comment</div>{r.pinned_comment}</div>
              </div>
            </div>
          ))}
        </>
      )}
    />
  );
}
